// extracted by css-extract-rspack-plugin
module.exports =  {"item":"CrumblepathItem-nNTy__item","label":"CrumblepathItem-n6mT__label","index":"CrumblepathItem-MIDB__index"};